export enum ActionSaveTypesEnum {
  MAPPING_LS = 'MAPPING_LS',
  MAPPING_NO = 'MAPPING_NO',
  MAPPING_ALL = 'MAPPING_ALL'
}
